<template>
  <div>
    <div class="row">
      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
        <div class="card card-charges pb-3">
          <div class="row">
            <div class="col-8 align-self-center">
              <h2 class="subtitle mb-0">
                {{ formatBookingTypeLabel(serviceType) }}
              </h2>
            </div>
            <div class="col-4 align-self-center text-right">
              <span
                class="button-edit-min"
                @click="managePrices(operation, mode, status)"
                v-if="mode === 'edit'"
                >Edit</span
              >
            </div>
          </div>

          <table cellspacing="0" cellpadding="1" class="table-prices">
            <thead>
              <tr class="header-table">
                <th align="left" class="text-left" width="40%">
                  <span class="title-table">Description</span>
                </th>
                <th align="right" class="text-right" width="30%   ">
                  <span class="title-table">Net Price</span>
                </th>
                <th align="right" class="text-right" width="30%">
                  <span class="title-table">Gross Price</span>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-b-toggle="'details'"
                @click="handleCollapseDetails"
                class="collapse-charges"
              >
                <td align="left">
                  <span class="price price-link">Base Transfer</span>
                </td>

                <td align="right">
                  <span
                    class="price"
                    :class="{
                      'new-price':
                        pricing.net_price.amount !==
                        pricing.net_price.last_amount
                    }"
                    v-if="
                      pricing.net_price.amount !== pricing.net_price.last_amount
                    "
                  >
                    {{ currency.symbol }}
                    {{ formatPrice(pricing.net_price.last_amount) }}
                    {{ currency.code }}
                  </span>
                  <span
                    class="price"
                    :class="{
                      'old-price':
                        pricing.net_price.amount !==
                        pricing.net_price.last_amount
                    }"
                  >
                    {{ currency.symbol }}
                    {{ formatPrice(pricing.net_price.amount) }}
                    {{ currency.code }}</span
                  >
                </td>
                <td align="right">
                  <span
                    class="price"
                    :class="{
                      'new-price':
                        pricing.gross_price.amount !==
                        pricing.gross_price.last_amount
                    }"
                    v-if="
                      pricing.gross_price.amount !==
                        pricing.gross_price.last_amount
                    "
                  >
                    {{ currency.symbol }}
                    {{ formatPrice(pricing.gross_price.last_amount) }}
                    {{ currency.code }}
                  </span>
                  <span
                    class="price"
                    :class="{
                      'old-price':
                        pricing.gross_price.amount !==
                        pricing.gross_price.last_amount
                    }"
                  >
                    {{ currency.symbol }}
                    {{ formatPrice(pricing.gross_price.amount) }}
                    {{ currency.code }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>

          <b-collapse id="details" role="tabpanel">
            <div
              v-for="(detail, index) in netPriceDetails"
              :key="`${detail.type}-${index}`"
              colspan="3"
              width="100%"
              class="collapse-charges"
            >
              <table
                width="100%"
                cellspacing="0"
                cellpadding="0"
                class="table-prices"
                style="border-top:0; margin-top:0;"
              >
                <thead>
                  <tr>
                    <th align="left" width="40%" class="text-left"></th>
                    <th align="right" width="30%" class="text-right"></th>
                    <th align="right" width="30%" class="text-right"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="left">
                      <span class="price pl-3">• {{ detail.name }} </span>
                    </td>
                    <td align="right">
                      <span
                        class="price"
                        :class="{
                          'old-price':
                            pricing.net_price.amount !==
                            pricing.net_price.last_amount
                        }"
                      >
                        {{ currency.symbol }}
                        {{ formatPrice(detail.amount) }}
                        {{ currency.code }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-collapse>

          <base-alert
            type="info"
            class="info-min mt-2 mb-0"
            v-if="pricing.reason_adjustment"
            ><i class="flaticon-warning mr-1"></i
            ><strong>Price modified due to:</strong>
            {{ pricing.reason_adjustment }}</base-alert
          >
        </div>
      </div>

      <div
        class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12"
        v-if="pricing.extras.length > 0"
      >
        <div class="card card-charges pb-3">
          <div class="row">
            <div class="col-8 align-self-center">
              <h2 class="subtitle mb-0">
                Extra Charges
              </h2>
            </div>
            <div class="col-4 align-self-center text-right">
              <span
                class="button-edit-min"
                @click="editExtraCharges()"
                v-if="mode === 'edit' || mode === 'new'"
                >Edit</span
              >
            </div>
          </div>

          <table cellspacing="0" cellpadding="1" class="table-prices">
            <thead>
              <tr class="header-table">
                <th align="left" class="text-left" width="40%">
                  <span class="title-table">Description</span>
                </th>
                <th align="right" class="text-right" width="30%">
                  <span class="title-table">Net Price</span>
                </th>
                <th align="right" class="text-right" width="30%">
                  <span class="title-table">Gross Price</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(extra, index) in pricing.extras">
                <td align="left">
                  <span class="price">{{ extra.description }}</span>
                </td>

                <td align="right">
                  <span class="price">
                    {{ currency.symbol }}
                    {{ formatPrice(extra.net_price) }}
                    {{ currency.code }}</span
                  >
                </td>
                <td align="right">
                  <span class="price">
                    {{ currency.symbol }} {{ formatPrice(extra.gross_price) }}
                    {{ currency.code }}</span
                  >
                </td>
              </tr>
              <tr class="footer-table">
                <td align="left">
                  <span class="totals">Total Extras</span>
                </td>
                <td align="right">
                  <span class="totals">
                    {{ currency.symbol }}
                    {{ formatPrice(pricing.totals.extras.net_price) }}
                    {{ currency.code }}
                  </span>
                </td>
                <td align="right">
                  <span class="totals">
                    {{ currency.symbol }}
                    {{ formatPrice(pricing.totals.extras.gross_price) }}
                    {{ currency.code }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12"
        v-if="pricing.discounts.length > 0"
      >
        <div class="card card-charges pb-3">
          <div class="row">
            <div class="col-8 align-self-center">
              <h2 class="subtitle mb-0">
                Discounts
              </h2>
            </div>
            <div class="col-4 align-self-center text-right">
              <span
                class="button-edit-min"
                @click="editDiscounts()"
                v-if="mode === 'edit' || mode === 'new'"
                >Edit</span
              >
            </div>
          </div>

          <table cellspacing="0" cellpadding="1" class="table-prices">
            <thead>
              <tr class="header-table">
                <th align="left" class="text-left" width="40%">
                  <span class="title-table">Description</span>
                </th>
                <th align="right" class="text-right" width="30%">
                  <span class="title-table">Percent</span>
                </th>
                <th align="right" class="text-right" width="30%">
                  <span class="title-table">Total</span>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(discount, index) in pricing.discounts">
                <td align="left">
                  <span class="price">{{ discount.description }}</span>
                </td>

                <td align="right">
                  <span class="price" v-if="discount.type === 'percentage'">
                    {{ discount.percent }}%</span
                  >
                  <span class="price" v-else>-</span>
                </td>
                <td align="right">
                  <span class="price">
                    {{ currency.symbol }} {{ discount.total }}
                    {{ currency.code }}</span
                  >
                </td>
              </tr>
              <tr class="footer-table">
                <td align="left">
                  <span class="totals">Total Discounts</span>
                </td>
                <td align="right"></td>
                <td align="right">
                  <span class="totals">
                    {{ currency.symbol }}
                    {{ formatPrice(pricing.totals.discounts) }}
                    {{ currency.code }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12"
        v-if="showPlatformPartnerFees"
      >
        <div class="card card-charges pb-3">
          <h2 class="subtitle mb-0">
            Platform & Partner Fees
          </h2>

          <table cellspacing="0" cellpadding="1" class="table-prices">
            <thead>
              <tr class="header-table">
                <th align="left" class="text-left" width="40%">
                  <span class="title-table">Description</span>
                </th>
                <th align="right" class="text-right" width="30%">
                  <span class="title-table">Percent</span>
                </th>
                <th align="right" class="text-right" width="30%">
                  <span class="title-table">Total</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="commissions.payment_processor.percentage > 0">
                <td align="left">
                  <span class="price">Stripe Fee</span>
                </td>

                <td align="right">
                  <span class="price">
                    {{ commissions.payment_processor.percentage }} %</span
                  >
                </td>

                <td align="right">
                  <span class="price">
                    {{ currency.symbol }}
                    {{ formatPrice(commissions.payment_processor.amount) }}
                    {{ currency.code }}
                  </span>
                </td>
              </tr>
              <tr v-if="commissions.platform.percentage > 0">
                <td align="left">
                  <span class="price">Partner Commission</span>
                </td>

                <td align="right">
                  <span class="price">
                    {{ commissions.platform.percentage }}%</span
                  >
                </td>

                <td align="right">
                  <span class="price">
                    {{ currency.symbol }}
                    {{ formatPrice(commissions.platform.amount) }}
                    {{ currency.code }}
                  </span>
                </td>
              </tr>
              <tr class="footer-table">
                <td align="left">
                  <span class="totals">Total Fees</span>
                </td>
                <td align="right"></td>
                <td align="right">
                  <span class="totals">
                    {{ currency.symbol }}
                    {{
                      formatPrice(
                        calculateTotalCommissions([
                          commissions.platform.amount,
                          commissions.payment_processor.amount
                        ])
                      )
                    }}
                    {{ currency.code }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
        <div class="card card-charges">
          <h2 class="subtitle mb-0">Summary</h2>

          <table cellspacing="0" cellpadding="1" class="table-prices mt-1">
            <tbody>
              <tr>
                <td align="left">
                  <span class="totals">
                    Total Net Price
                  </span>
                </td>
                <td align="right">
                  <span class="totals">
                    {{ currency.symbol }}
                    {{ formatPrice(pricing.totals.net_price) }}
                    {{ currency.code }}
                  </span>
                </td>
              </tr>

              <tr>
                <td align="left">
                  <span class="totals">
                    Total Gross Price
                  </span>
                </td>
                <td align="right">
                  <span class="totals">
                    {{ currency.symbol }}
                    {{ formatPrice(pricing.totals.gross_price) }}
                    {{ currency.code }}
                  </span>
                </td>
              </tr>

              <tr>
                <td align="left">
                  <span class="totals">
                    Total Gross Profit
                  </span>
                </td>
                <td align="right">
                  <span class="totals">
                    {{ currency.symbol }}
                    {{
                      formatPrice(
                        calculateGrossProfit(
                          pricing.totals.gross_price,
                          pricing.totals.net_price
                        )
                      )
                    }}
                    {{ currency.code }}
                  </span>
                </td>
              </tr>

              <tr>
                <td align="left">
                  <span class="totals">
                    Total Net Profit
                  </span>
                </td>
                <td align="right">
                  <span
                    class="totals"
                    :class="pricing.totals.net_profit < 0 ? 'loss-alert' : ''"
                  >
                    {{ currency.symbol }}
                    {{ formatPrice(pricing.totals.net_profit) }}
                    {{ currency.code }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
        <div class="card box-total">
          <div class="rows-extra">
            <div class="row">
              <div
                class="col-xl-6 col-lg-6 col-md-7 col-sm-7 col-7 align-self-center"
              >
                <span class="subtitle mb-0">TOTAL CHARGES</span>
              </div>

              <div
                class="col-xl-6 col-lg-6 col-md-5 col-sm-5 col-5 text-right align-self-center"
              >
                <span
                  class="subtitle mb-0"
                  :class="pricing.totals.gross_price < 0 ? 'loss-alert' : ''"
                >
                  {{ currency.symbol }}
                  {{ formatPrice(pricing.totals.gross_price) }}
                  {{ currency.code }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  formatBookingTypeLabel,
  formatPrice,
  calculateGrossProfit,
  calculateTotalCommissions
} from "./services/format.service";
import { buildNetPriceDetails } from "./services/price-details.service";

export default {
  name: "charges",
  props: {
    currency: {
      code: {
        type: String,
        default: "",
        description: "",
        required: true
      },
      symbol: {
        type: String,
        default: "",
        description: "",
        required: true
      }
    },
    pricing: {
      type: Object,
      required: true
    },
    commissions: {
      type: Object,
      required: true
    },
    operation: {
      type: String,
      default: "view",
      description: "(reservation mode: new, edit)",
      required: true
    },
    mode: {
      type: String,
      default: "view",
      description: "(edit-view)",
      required: true
    },
    status: {
      type: String,
      default: "",
      description: "(draft)",
      required: false
    },
    markUp: {
      type: Number,
      required: true
    },
    markUpType: {
      type: String,
      required: true
    },
    adjustmentsAvailable: {
      type: Boolean,
      required: false
    },
    serviceType: {
      type: String,
      default: "transfer",
      description: "Type of service (transfer, experience)",
      validator: function(value) {
        return ["transfer", "experience"].includes(value);
      },
      required: false
    },
    surcharges: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      collapseDetails: "EXPAND",
      adjustPrices: false
    };
  },
  methods: {
    formatBookingTypeLabel,
    formatPrice,
    calculateGrossProfit,
    calculateTotalCommissions,
    handleCollapseDetails() {
      if (this.collapseDetails === "EXPAND") {
        this.collapseDetails = "COLLAPSE";
      } else {
        this.collapseDetails = "EXPAND";
      }
    },
    editDiscounts() {
      this.$emit("addAdjustments", "discounts");
    },
    editExtraCharges() {
      this.$emit("addAdjustments", "extraCharges");
    },
    managePrices(operation, mode, status) {
      if (this.adjustmentsAvailable) {
        if (["edit", "new"].includes(operation) && mode === "edit") {
          if (["BI", "DRAFT"].includes(status)) {
            this.adjustPrices = !this.adjustPrices;
          } else {
            this.$emit("addAdjustments", "prices");
          }
        } else {
          this.adjustPrices = !this.adjustPrices;
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `We have detected that you have not selected any available service or customer.`,
          icon: "flaticon-warning-1"
        });
      }
    }
  },
  computed: {
    showPlatformPartnerFees() {
      const paymentProcessor = this.commissions.payment_processor || {};
      const platform = this.commissions.platform || {};
      return (
        (paymentProcessor.percentage && paymentProcessor.percentage > 0) ||
        (platform.percentage && platform.percentage > 0)
      );
    },
    netPriceDetails() {
      return buildNetPriceDetails(
        this.pricing.net_price.amount,
        this.pricing.base_price.composition,
        this.surcharges
      );
    }
  }
};
</script>
